// LLM generated - Model Claude 4 Sonnet
import { Box, Flex, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import { LinkButton } from '~/domains/design-system/Button';
import IconGiftAurora from '~/domains/design-system/icons/IconGiftAurora';
import type { NormalizedBonus } from '~/domains/promotions/types/bonus.types';

import { useStyles } from './DepositBonusBanner.styles';

const WARNING_ICON_SIZE = 12;

interface DepositBonusBannerProps {
  bonus: NormalizedBonus;
  onDetailsClick?: () => void;
}

function PredictionMarketsWarning() {
  const { classes } = useStyles();
  const { t } = useTranslation('payments');

  return (
    <Box className={classes.predictionMarketsWarning}>
      <IconAlertTriangle
        size={WARNING_ICON_SIZE}
        className={classes.predictionMarketsWarningIcon}
        aria-hidden
      />
      <Text variant="body-medium" className={classes.predictionMarketsWarningCopy}>
        {t('deposits.bonusBanner.predictionMarketsWarning')}
      </Text>
    </Box>
  );
}

export function DepositBonusBanner({ bonus, onDetailsClick }: DepositBonusBannerProps) {
  const { classes } = useStyles();
  const { t } = useTranslation('payments');

  return (
    <Box className={classes.card}>
      <Flex
        align="center"
        /* eslint-disable-line local-rules/use-theme-tokens */ gap={16}
        className={classes.bonusRow}
      >
        <Box className={classes.iconContainer}>
          <IconGiftAurora size={32} />
        </Box>

        <Stack
          className={classes.textContent}
          /* eslint-disable-line local-rules/use-theme-tokens */ spacing={4}
        >
          <Text variant="subhead-medium" c="gray2.6">
            {bonus.title}
          </Text>
          <Text variant="subhead-small" c="gray2.3">
            {bonus.subtitle}
          </Text>
        </Stack>

        <LinkButton
          variant="primary-text"
          mode="linkButton"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDetailsClick?.();
          }}
          className={classes.detailsLink}
        >
          {t('deposits.bonusBanner.details')}
        </LinkButton>
      </Flex>

      <PredictionMarketsWarning />
    </Box>
  );
}
